import React, {Component} from 'react';
import {Breadcrumb, BreadcrumbItem, Col, Container, Row} from "mdbreact";
import {Link} from "react-router-dom";
import UserPanelMenu from "../../components/user/UserPanelMenu";


class UsersPage extends Component {

    render() {
        return (
            <div className="pt-3">
                <Container>
                    <Breadcrumb className='w-100 white mt-3 rtl'>
                        <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                        <BreadcrumbItem><Link to="/users">کاربر</Link></BreadcrumbItem>
                        <BreadcrumbItem active> صفحه کاربری</BreadcrumbItem>
                    </Breadcrumb>
                    <Row className='mt-3 md-5 rtl'>
                        <Col md='3' sm='12' className="">
                            <div className="panel panel-default sidebar-menu white">

                                <div className="panel-heading">
                                    <h3 className="panel-title">بخش های کاربر</h3>
                                </div>

                                <div className="panel-body">

                                   <UserPanelMenu activeElement="1"/>
                                </div>

                            </div>
                        </Col>
                        <Col md='9' sm='12' >
                            <div className='white p-3'>
                            <h3>به بخش کاربری سامانه خوش آمدید.</h3>
                            </div>
                        </Col>

                    </Row>
                </Container>
            </div>
        );
    }
}


export default UsersPage;



// WEBPACK FOOTER //
// ./src/containers/user/UsersPage.js